/* eslint-disable no-case-declarations */
import { Descendant, Text } from 'slate';
import { ElementTypes } from 'src/types/CustomSlateTypes';

const hash = require('hash-sum');

export type ElementsMetadata = {
  mentions?: { [mentionId: string]: { userId: string, username: string } },
  quotes?: {
    [quoteId: string]: {
      postId: string,
      content: string,
      userId: string
    } },
};

const getElementsMetadata = (nodes: Descendant[]) => {
  const metadata: ElementsMetadata = {};

  const getNodesMetadata = (node: Descendant) => {
    if (Text.isText(node)) return;

    node.children.forEach((n: Descendant) => getNodesMetadata(n));
    switch (node.type) {
      case ElementTypes.mention:
        const { userId, username } = node;
        if (!metadata.mentions) metadata.mentions = {};
        const mentionId = hash(userId);
        metadata.mentions[mentionId] = { userId, username };
        break;
      case ElementTypes.quote:
        const {
          quoteId, content, postId, userId: quoteUserId,
        } = node;
        if (!metadata.quotes) metadata.quotes = {};
        const contentDocument = new DOMParser().parseFromString(content, 'text/html');
        const mentionElements = contentDocument.querySelectorAll('[data-mentionid]');
        let quoteContent = content;
        if (mentionElements.length > 0) {
          if (!metadata.mentions) metadata.mentions = {};
          (mentionElements).forEach((element) => {
            const mentionIdAttribute = element.getAttribute('data-mentionid') as string;
            const mentionUserId = element.getAttribute('data-mention-userid');
            const mentionUsername = element.getAttribute('data-mention-username');
            metadata.mentions![mentionIdAttribute] = {
              userId: mentionUserId!,
              username: mentionUsername!,
            };
            const mentionElement = contentDocument.createElement('forums-mention');
            mentionElement.setAttribute('id', mentionIdAttribute);
            if (element.parentElement && element.parentElement.getAttribute('data-mentions-link')) {
              element.parentElement.replaceWith(mentionElement);
            } else {
              element.replaceWith(mentionElement);
            }
          });
          quoteContent = contentDocument.body.innerHTML;
        }
        metadata.quotes[quoteId] = { content: quoteContent, postId, userId: quoteUserId };
        break;
      default:
    }
  };

  nodes.forEach((n) => { getNodesMetadata(n); });
  return metadata;
};

export default getElementsMetadata;
